import axios from "axios";

const requestInfoAddress = axios.create({
    baseURL: 'https://provinces.open-api.vn'
})

export default requestInfoAddress